/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import {
  EarlyExerciseConfigurationService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetEarlyExerciseConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  planTypeCategoryId: string
): UseQueryResult<
  | Wealthlane_AwardSettlementService_Dtos_EarlyExerciseConfiguration_ConfigureExerciseConfigurationDto
  | undefined,
  unknown
> => {
  const earlyExerciseConfig = useQuery(['getEarlyExerciseConfig'], async () => {
    return await handleRequest(
      EarlyExerciseConfigurationService.getApiAwardSettlementApiAppEarlyExerciseConfigurationEarlyExerciseConfiguration(
        planTypeCategoryId
      )
    );
  });
  return earlyExerciseConfig;
};

export default useGetEarlyExerciseConfig;
